<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de costos</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-btn @click="costoListaUpdate" color="orange" flat dark>Actualizar costos</v-btn>
                <v-btn @click="origenModalOpen" color="blue" flat dark>Origen de precios</v-btn>
                <v-btn @click.stop="precioUpdateModal = true" color="amber" flat dark>Actualiza precios</v-btn>
                <v-btn @click="precioLista" color="purple" flat dark>Genera lista</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pag"
                        :total-items="totalItems"
                        :loading="loading"
                        :rows-per-page-items="rowsPerPage"
                        rows-per-page-text="Filas por pagina"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        item-key="id"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.item.created_at }}</td>
                        <td class="text-xs-center">{{ props.item.updated_at }}</td>
                        <td class="text-xs-center">
                            <v-tooltip fixed top>
                                <span slot="activator">{{ props.item.producto_id }}</span>
                                <span>{{ props.item.descripcion }}</span>
                            </v-tooltip>
                        </td>
                        <td class="text-xs-center">{{ props.item.um }}</td>
                        <td class="text-xs-center">
                            <v-avatar :size="30" v-if="props.item.empresa && props.item.empresa.avatar">
                                <img :src="props.item.empresa.avatar" alt="avatar">
                            </v-avatar>
                        </td>
                        <td class="text-xs-center">{{ props.item.ubicacion }}</td>
                        <td class="text-xs-center">{{ props.item.valor | moneda}}</td>
                        <td class="text-xs-center">{{ props.item.porcentaje }}</td>
                        <td class="text-xs-center">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.item)">
                                <span style="width: 100%">{{ props.item.precio | moneda }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="precioNuevo"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-tooltip fixed top>
                                <v-icon small slot="activator" :color="(props.item.estado_tipo === 1)? 'green' : 'red'">{{ (props.item.estado_tipo === 1)? 'check' : 'error'}}</v-icon>
                                <span>{{ props.item.estado }}</span>
                            </v-tooltip>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <!--/******************************* GESTION DE ORIGEN DE PRECIOS *******************************/-->
        <v-dialog v-model="origenModal" width="900">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Gestión de origen de precios</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="origenModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout align-center>
                        <v-flex>
                            <v-select label="Tipo panel" v-model="orig.tipo" :items="tipos" item-value="variable" item-text="desc"></v-select>
                        </v-flex>
                        <v-flex>
                            <v-select label="Núcleo" v-model="orig.nucleo" :items="nucleos" item-value="variable" item-text="desc"></v-select>
                        </v-flex>
                        <v-flex>
                            <v-select label="Revest ext" v-model="orig.ext_rev" :items="revs" item-value="variable" item-text="desc"></v-select>
                        </v-flex>
                        <v-flex>
                            <v-select label="Revest int" v-model="orig.int_rev" :items="revs" item-value="variable" item-text="desc"></v-select>
                        </v-flex>
                        <v-flex>
                            <ubiacion-select label="Ubicacion" v-model="orig.ubicacion"></ubiacion-select>
                        </v-flex>
                        <v-flex>
                            <empresa-select v-model="orig.empresa_id"></empresa-select>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Porcentaje" v-model="orig.porcentaje"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-btn flat dark icon color="green" @click="precioAdd">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-data-table
                        :headers="headersOrigen"
                        :items="itemsOrigen"
                        :total-items="totalItemsOrigen"
                        :loading="origenLoading"
                        :rows-per-page-items="rowsPerPage"
                        rows-per-page-text="Filas por pagina"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        item-key="id"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.item.tipo }}</td>
                        <td class="text-xs-center">{{ props.item.nucleo }}</td>
                        <td class="text-xs-center">{{ props.item.ubicacion }}</td>
                        <td class="text-xs-center">{{ props.item.empresa_id }}</td>
                        <td class="text-xs-center">{{ props.item.porcentaje }}</td>
                        <td class="text-xs-center">
                            <v-btn flat icon color="red" :loading="deleteLoading === props.item.id" @click="precioDelete(props.item.id)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-card>
        </v-dialog>
        <!--/******************************* GESTION DE ACTUALIZACION DE PRECIOS *******************************/-->
        <v-dialog v-model="precioUpdateModal" width="900">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Gestión de actualización de precios</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.stop="precioUpdateModal = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark @click.stop="precioUpdateModal = false" color="red">Cancelar</v-btn>
                    <v-btn dark @click="precioUpdate" color="green">Actualizar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import empresaSelect from '../../components/EmpresaSelect';
    import ubiacionSelect from '../../components/UbicacionSelect';
    import mixinCosto from '../../mixins/costo';
    import mixinPrecioOrigen from '../../mixins/precio_origen';
    import {mapActions, mapGetters} from 'vuex';
    import moneda from '../../filters/moneda';

    function origInitial() {
        return {
            tipo: '',
            nucleo: '',
            empresa_id: '',
            ubicacion: '',
            porcentaje: 0,
            ext_rev: '',
            int_rev: ''
        }
    }

    export default {
        name: "gestion",
        components: {empresaSelect, ubiacionSelect},
        mixins: [mixinCosto, mixinPrecioOrigen],
        filters: {moneda},
        data() {
            return {
                loading: false,
                origenModal: false,
                precioUpdateModal: false,
                origenLoading: false,
                deleteLoading: -1,
                pag: {},
                totalItems: 0,
                items: [],
                headers: [
                    {text: 'F. Creación', value: 'created_at', align: 'center'},
                    {text: 'F. Actualiz.', value: 'updated_at', align: 'center'},
                    {text: 'Producto', value: 'producto_id', align: 'center'},
                    {text: 'UM', value: 'um', align: 'center'},
                    {text: 'Empresa', value: 'empresa_id', align: 'center'},
                    {text: 'Ubicación', value: 'ubicacion', align: 'center'},
                    {text: 'Costo', value: 'valor', align: 'center'},
                    {text: 'Porcentaje', value: 'porcentaje', align: 'center'},
                    {text: 'Precio', value: 'precio', align: 'center'},
                    {text: 'Estado', value: 'estado_tipo', align: 'center'},
                ],
                totalItemsOrigen: 0,
                itemsOrigen: [],
                headersOrigen: [
                    {text: 'Tipo panel', value: 'tipo', align: 'center'},
                    {text: 'Núcleo', value: 'nucleo', align: 'center'},
                    {text: 'Ubicación', value: 'ubicacion', align: 'center'},
                    {text: 'Empresa', value: 'empresa_id', align: 'center'},
                    {text: 'Porcentaje', value: 'porcentaje', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                rowsPerPage: [20, 40, 80, 100, {text: 'Todo', value: -1}],
                tipos: [],
                nucleos: [],
                revs: [],
                orig: origInitial(),
                precioNuevo: 0
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {
            this.tabla();
            this.costoDatos(r => {
                this.tipos = r.tipos;
                this.nucleos = r.nucleos;
                this.revs = r.rev;
            }, err => console.error(err));
            this.precioOrigenTable();
        },
        methods: {
            ...mapActions('progreso', ['progresoShow', 'progresoHide', 'progresoPorcent']),
            ...mapActions('notif', ['msjShow']),
            editar(item) {
                this.loading = true;
                this.costoUpdate(item.id, {precio: this.precioNuevo}, r => {
                    this.msjShow(r);
                    item.precio = this.precioNuevo;
                    this.precioNuevo = '';
                    this.loading = false;
                }, err => {
                    console.error('Error');
                    this.loading = false;
                });
                return false;
            },
            precioLista() {
                // this.$http.get('/precio/importacion');
                let url = window.Laravel.urlBase + '/precio/importacion';
                let es = new EventSource(url);
                this.progresoShow({tit: 'Procesando exportación de precios'});
                es.addEventListener('message', event => {
                    let data = JSON.parse(event.data);
                    if (data.prog === 'fin') {
                        es.close();
                        this.tabla();
                        this.progresoHide();
                    } else {
                        this.progresoPorcent({porcent: data.prog, msj: data.msj})
                    }
                });
                es.addEventListener('error', event => {
                    if (event.readyState === EventSource.CLOSED) {
                        console.log('Event was closed');
                        console.log(EventSource);
                    }
                    console.log(event);
                    es.close();
                    this.progresoHide();
                }, false);


            },
            precioAdd() {
                this.precioOrigenStore(this.orig, r => {
                    this.msjShow(r);
                    this.precioOrigenTable();
                    this.orig = origInitial();
                }, err => console.error(err))
            },
            precioDelete(id) {
                this.deleteLoading = id;
                this.precioOrigenDestroy(id, r => {
                    this.deleteLoading = -1;
                    this.msjShow(r);
                    this.precioOrigenTable();
                }, err => {
                    console.error(err)
                    this.deleteLoading = -1;
                })
            },
            precioOrigenTable() {
                this.origenLoading = true;
                this.precioOrigenIndex(r => {
                    this.itemsOrigen = r;
                    this.origenLoading = false;
                }, err => {
                    this.origenLoading = false;
                    console.error(err)
                })
            },
            precioUpdate() {
                // this.$http.get('precio-origen/generar');
                let url = window.Laravel.urlBase + '/precio-origen/generar';
                let es = new EventSource(url);
                this.progresoShow({tit: 'Procesando lista de precios'});
                es.addEventListener('message', event => {
                    let data = JSON.parse(event.data);
                    if (data.prog === 'fin') {
                        es.close();
                        this.tabla();
                        this.progresoHide();
                    } else {
                        this.progresoPorcent({porcent: data.prog, msj: data.msj})
                    }
                });
                es.addEventListener('error', event => {
                    if (event.readyState === EventSource.CLOSED) {
                        console.log('Event was closed');
                        console.log(EventSource);
                    }
                    console.log(event);
                    es.close();
                    this.progresoHide();
                }, false);
            },
            costoListaUpdate() {
                // this.$http.get('/costo/generar')
                let url = window.Laravel.urlBase + '/costo/generar';
                let es = new EventSource(url);
                this.progresoShow({tit: 'Procesando lista de costos'});
                es.addEventListener('message', event => {
                    let data = JSON.parse(event.data);
                    if (data.prog === 'fin') {
                        es.close();
                        this.tabla();
                        this.progresoHide();
                    } else {
                        this.progresoPorcent({porcent: data.prog, msj: data.msj})
                    }
                });
                es.addEventListener('error', event => {
                    if (event.readyState === EventSource.CLOSED) {
                        console.log('Event was closed');
                        console.log(EventSource);
                    }
                    console.log(event);
                    es.close();
                    this.progresoHide();
                }, false);
            },
            tabla() {
                this.loading = true;
                this.pag.filtros = this.d;
                this.costoIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            origenModalOpen() {
                this.origenModal = true;
            }
        }
    }
</script>

<style>
    .v-menu__activator a {
        width: 100% !important;
        text-align: right !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/costos/gestion.vue